import React from 'react'
import { cn } from '../../lib/utils'
import {
  CoachNotes,
  CoachServicesCircle,
  Dashboard,
  Entrepreneurship,
  Interview,
  InterviewDeloitte,
  JobTargeting,
  Networking,
  OnboardingSuccess,
  Orientation,
  PersonalBrand,
  Research,
  Retirement,
  SampleDoc,
  Settings,
  Skills,
  Wellness,
} from '../icons/YnsIcon'

export const getIcon = (name) => {
  const icons = {
    coachServices: CoachServicesCircle,
    dashboard: Dashboard,
    home: Dashboard, // Using dashboard for home as per current implementation
    orientation: Orientation,
    careerAdvisement: CoachServicesCircle, // Using coach-services as per current implementation
    scheduleCoaching: Orientation, // Using orientation as per current implementation
    jobTargeting: JobTargeting,
    actionPlanMiniPlatform: JobTargeting, // Using job-targeting as per current implementation
    skills: Skills,
    personalBrand: PersonalBrand,
    resume: SampleDoc, // Using sample-doc for resume
    coachNotes: CoachNotes,
    networking: Networking,
    research: Research,
    interview: Interview,
    interviewDeloitte: InterviewDeloitte,
    onboardingSuccess: OnboardingSuccess,
    guidesMiniPlatform: OnboardingSuccess, // Using onboarding-success as per current implementation
    entrepreneurship: Entrepreneurship,
    retirement: Retirement,
    wellness: Wellness,
    settings: Settings,
  }
  return icons[name]
}

export const Bar = ({ isColored, theme = 'blue', className }) => {
  let notColoredFill = 'fill-cod-gray-200'
  let themeFill = 'fill-[#E0F2F9]'
  switch (theme) {
    case 'green':
      themeFill = 'fill-[#1E7129]'
      break
    case 'deloitte':
      themeFill = 'fill-black'
      notColoredFill = 'fill-deloitte'
  }
  const barClass = cn(
    'fill-[#E0F2F9]',
    className,
    !isColored && notColoredFill,
    isColored && themeFill,
  )
  return (
    <svg
      role="img"
      width="2"
      height="50"
      viewBox="0 0 2 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={barClass}
    >
      <title>subnav decoration bar</title>
      <path d="M0 0H2V125C0.895431 125 0 124.105 0 123V0Z" />
      <path d="M0 0H2V125C0.895431 125 0 124.105 0 123V0Z" />
    </svg>
  )
}

export const SplitBar = ({ theme = 'blue', className }) => {
  let topStroke = 'stroke-[#E0F2F9]'
  let bottomStroke = 'stroke-[#D1D1D1]'
  switch (theme) {
    case 'green':
      topStroke = 'stroke-[#1E7129]'
      break
    case 'deloitte':
      topStroke = 'stroke-black'
      bottomStroke = 'stroke-deloitte'
  }
  return (
    <svg
      role="img"
      width={2}
      height={50}
      viewBox="0 0 2 50"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>active subnav decoration bar</title>
      <g strokeWidth={2}>
        <path className={topStroke} d="M1 0v25" />
        <path className={bottomStroke} d="M1 25v25" />
      </g>
    </svg>
  )
}
